import { endOfDay } from "date-fns";
import { z } from "zod";

export const formSchema = z.object({
	goalValue: z.number().nullable(),
	incrementValue: z.number().nullable(),
	isIncrement: z.boolean(),
	message: z.string(),
	asOfDate: z
		.date()
		.nullable()
		.refine((date) => !date || date <= endOfDay(new Date()), {
			message: "Date cannot be in the future",
		}),
	outlookId: z.string().nullable(),
});

export type FormValues = z.infer<typeof formSchema>;
